function htmlMarkup(html) {
  return { __html: html || '' }
}

export function ContentPageApp({ payload }) {
  switch (payload.template) {
    case 'search':
      return <SearchResultsPage payload={payload} />
    case 'archive':
      return <ArchivePage payload={payload} />
    case '404':
      return <NotFoundPage payload={payload} />
    case 'page':
    default:
      return <StaticPage payload={payload} />
  }
}

function StaticPage({ payload }) {
  const post = payload.post || {}

  return (
    <article id={post.id ? `post-${post.id}` : undefined} className={post.classes || ''}>
      <header className="entry-header">
        <h1 className="entry-title">{post.title}</h1>
      </header>

      <div className="entry-content" dangerouslySetInnerHTML={htmlMarkup(post.contentHtml)} />
    </article>
  )
}

function ArchivePage({ payload }) {
  const posts = Array.isArray(payload.posts) ? payload.posts : []

  if (!posts.length) {
    return (
      <article className="no-results not-found">
        <h1 className="page-title">{payload.emptyTitle || 'Bienvenue sur Nova Theme'}</h1>
        <p>{payload.emptyText || 'Le theme est actif.'}</p>
      </article>
    )
  }

  return (
    <>
      {posts.map((post) => (
        <article id={`post-${post.id}`} className={post.classes} key={post.id}>
          <h2 className="entry-title">
            <a href={post.permalink}>{post.title}</a>
          </h2>

          <div className="entry-content" dangerouslySetInnerHTML={htmlMarkup(post.contentHtml)} />
        </article>
      ))}

      <div dangerouslySetInnerHTML={htmlMarkup(payload.navigationHtml)} />
    </>
  )
}

function SearchResultsPage({ payload }) {
  const results = Array.isArray(payload.results) ? payload.results : []

  return (
    <div className="site-panel__shop-layout">
      <div className="site-panel__shop-content">
        <header className="woocommerce-products-header nova-search-header">
          <p className="nova-search-header__eyebrow">{payload.labels?.eyebrow || 'Recherche'}</p>
          <h1 className="woocommerce-products-header__title page-title">{payload.title}</h1>
          <p className="nova-search-header__summary">{payload.summary}</p>
          <div className="nova-search-form" dangerouslySetInnerHTML={htmlMarkup(payload.searchFormHtml)} />
        </header>

        {results.length ? (
          <>
            <div className="nova-search-results-grid">
              {results.map((result) => (
                <SearchResultCard result={result} labels={payload.labels || {}} key={result.id} />
              ))}
            </div>

            <div dangerouslySetInnerHTML={htmlMarkup(payload.paginationHtml)} />
          </>
        ) : (
          <section className="nova-search-empty no-results not-found">
            <span className="nova-search-empty__icon" aria-hidden="true">
              <i className="bi bi-search" />
            </span>
            <h2 className="nova-search-empty__title">{payload.labels?.emptyTitle || 'Aucun resultat trouve'}</h2>
            <p>{payload.labels?.emptyText || 'Essayez avec un autre mot-cle ou une recherche plus courte.'}</p>
          </section>
        )}
      </div>
    </div>
  )
}

function SearchResultCard({ result, labels }) {
  const buttonLabel = result.isProduct ? labels.viewProduct : labels.viewResult

  return (
    <article id={`post-${result.id}`} className={`${result.classes || ''} nova-search-result-card`.trim()}>
      <a className="nova-search-result-card__media" href={result.permalink} aria-label={result.title}>
        {result.thumbnailHtml ? (
          <span dangerouslySetInnerHTML={htmlMarkup(result.thumbnailHtml)} />
        ) : (
          <span className="nova-search-result-card__placeholder" aria-hidden="true">
            <i className="bi bi-search" />
          </span>
        )}
      </a>

      <div className="nova-search-result-card__content">
        <span className="nova-search-result-card__type">{result.typeLabel}</span>
        <h2 className="nova-search-result-card__title">
          <a href={result.permalink}>{result.title}</a>
        </h2>

        {result.priceHtml ? (
          <div className="nova-search-result-card__price" dangerouslySetInnerHTML={htmlMarkup(result.priceHtml)} />
        ) : (
          <div className="nova-search-result-card__excerpt" dangerouslySetInnerHTML={htmlMarkup(result.excerptHtml)} />
        )}

        <a className="nova-search-result-card__button" href={result.permalink}>
          {buttonLabel || 'Voir le resultat'}
        </a>
      </div>
    </article>
  )
}

function NotFoundPage({ payload }) {
  const labels = payload.labels || {}

  return (
    <section className="nova-error-404" aria-labelledby="nova-error-404-title">
      <p className="nova-error-404__eyebrow">{labels.eyebrow || 'Erreur 404'}</p>

      <header className="nova-error-404__header">
        <div className="nova-error-404__code" aria-hidden="true">
          404
        </div>
        <h1 id="nova-error-404-title" className="nova-error-404__title">
          {labels.title || 'Page introuvable'}
        </h1>
      </header>

      <div className="nova-error-404__content">
        <p>{labels.textOne}</p>
        <p>{labels.textTwo}</p>
      </div>

      <div className="nova-error-404__search" dangerouslySetInnerHTML={htmlMarkup(payload.searchFormHtml)} />

      <div className="nova-error-404__actions">
        <a className="nova-error-404__button" href={payload.homeUrl}>
          {labels.home || 'Retour a l accueil'}
        </a>
        <a className="nova-error-404__link" href={payload.shopUrl}>
          {labels.shop || 'Voir la boutique'}
        </a>
      </div>
    </section>
  )
}
